import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function directUrl(img) {
  if (!img) return "";
  if (img.source_type === "url") return img.external_url;
  return `${BACKEND_URL}/api/file/${img.storage_path}`;
}

export function shortLink(img) {
  return `${window.location.origin}/s/${img.short_code}`;
}

export function buildEmbeds(img, overrideUrl) {
  const u = overrideUrl || directUrl(img);
  const alt = img.title || "image";
  return {
    direct: u,
    html: `<img src="${u}" alt="${alt}" />`,
    bbcode: `[img]${u}[/img]`,
    markdown: `![${alt}](${u})`,
    short: shortLink(img),
  };
}
